import * as yup from "yup";

export const signupSchema = yup.object().shape({
    firstName: yup.string()
        .required("First Name is requred")
        .min(3, "First name must be at lease 3 characters")
        .max(50, "First name can't be more than 50 characters"),
    lastName: yup.string()
        .required("Last Name is required")
        .min(3, "Last name must be at least 3 characters")
        .max(50, "Last name can't be more than 50 characters"),
    dateOfBirth: yup.date("Date should be in yyyy-MM-dd")
        .required("Date of birth is required"),
    username: yup.string().required(),
    email: yup.string()
        .required("Email is required")
        .email("Please enter a valid email"),
    password: yup.string()
        .required("Password is required")
})
